import { CapChartSecuritiesAccordion } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/CapChartSecuritiesDrawer/CapChartSecuritiesAccordion.tsx';
import {
	useTranslationCapChart,
	useTranslationCapTable,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { drawerTransitionProps } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling.tsx';
import { ChartSecuritiesTct } from '@dealstack/shared/lib/generated';
import { Accordion, Button, Drawer, Flex, Text } from '@mantine/core';
import { memo } from 'react';
import { CapChartSecuritiesAccordionProps } from './CapChartSecuritiesAccordion.types';

type Props = {
	opened: boolean;
	onClose: () => void;
	applySecuritiesView: () => void;
	resetSecuritiesView: () => void;
	securities: ChartSecuritiesTct[];
} & Pick<CapChartSecuritiesAccordionProps, 'setSelectSecurities' | 'selectedSecurities'>;

const CapChartSecuritiesDrawer = ({
	opened,
	onClose,
	securities,
	selectedSecurities,
	setSelectSecurities,
	applySecuritiesView,
	resetSecuritiesView,
}: Props) => {
	const tCapTable = useTranslationCapTable();
	const tCapChart = useTranslationCapChart();
	const allPeople = securities.flatMap((s) => s.person).filter((p) => !!p);

	return (
		<Drawer
			opened={opened}
			onClose={onClose}
			position="right"
			transitionProps={drawerTransitionProps}
			title={
				<Text size="B4Bold" truncate>
					{tCapTable('header_actions.specify_securities')}
				</Text>
			}
		>
			<Flex direction="column" gap="2rem" h="100%" justify="space-between">
				<Accordion
					chevronSize="md"
					multiple
					defaultValue={allPeople.map((person) => person.id)}
				>
					{securities?.map(({ person, securities: personSecurities }) =>
						person ? (
							<CapChartSecuritiesAccordion
								person={person}
								personSecurities={personSecurities}
								selectedSecurities={selectedSecurities}
								setSelectSecurities={setSelectSecurities}
								key={person.id}
							/>
						) : null
					)}
				</Accordion>

				<Flex direction="column" gap="0.5rem">
					<Button size="md" onClick={applySecuritiesView}>
						{tCapChart('specify_securities.drawer.apply_view')}
					</Button>
					<Button
						variant="ghost"
						size="md"
						onClick={resetSecuritiesView}
						fullWidth={true}
					>
						{tCapChart('specify_securities.drawer.quit_view')}
					</Button>
				</Flex>
			</Flex>
		</Drawer>
	);
};

const Memoized = memo(CapChartSecuritiesDrawer);

export { Memoized as CapChartSecuritiesDrawer };
